export default __webpack_public_path__ + "static/media/gallery_07.23e7ff67.jpg";